import React from 'react';
import { useSelector } from 'react-redux';

import { ErrorContainer, ErrorWrapper } from './404';

const sandTimerWarning = 'https://storage.googleapis.com/fplsblog/sand_timer_2.svg';

const ForbiddenError = () => {
  const { notFoundText } = useSelector((state) => state.form);

  return (
    <ErrorWrapper>
      <ErrorContainer>
        <img src="/static/images/logo/formplus-logo.png" id="formplus-logo" alt="Formplus Logo" width="85px" />
        <img src={sandTimerWarning} alt="Error Message" height={200} />
        <p style={{margin: '10px 0 0 0'}}>{notFoundText || 'Something went wrong' }</p>
      </ErrorContainer>
    </ErrorWrapper>
  );
};

export default ForbiddenError;
